import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import HomePage from "./HomePage";
import "./CSS/pricing.css";

function Pricing() {
  const [stylingOnClickPricing, setstylingOnClickPricing] = useState();
  useEffect(() => {
    setstylingOnClickPricing("MediumBlue");
  }, []);

  const [isAnnual, setIsAnnual] = useState(false);
  const [open, setOpen] = useState({});

  const handleOpen = (id) => {
    setOpen({ ...open, [id]: true });
  };
  const handleClose = (id) => {
    setOpen({ ...open, [id]: false });
  };

  return (
    <div className="pricing-page">
      <HomePage stylingOnClickPricing={stylingOnClickPricing} />

      {/* Hero Section */}
      <div className="pricing-hero">
        <div className="pricing-container">
          <span className="pricing-eyebrow">Your website. Your audience. Your growth.</span>
          <h2>Start free. Upgrade when you’re ready to grow.</h2>
          <p>
            Every plan starts with a home for your business. Choose the level of
            website, directory visibility and lead generation that fits your next step.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="pricing-container">
        {/* Pricing Toggle */}
        <div className="pricing-toggle">
          <button
            type="button"
            className={!isAnnual ? "active" : ""}
            onClick={() => setIsAnnual(false)}
            aria-pressed={!isAnnual}
          >
            Monthly Billing
          </button>
          <button
            type="button"
            className={`toggle-switch ${isAnnual ? "annual" : ""}`}
            onClick={() => setIsAnnual(!isAnnual)}
            aria-label={`Switch to ${isAnnual ? "monthly" : "annual"} billing`}
            aria-pressed={isAnnual}
          >
            <div className="toggle-slider"></div>
          </button>
          <button
            type="button"
            className={isAnnual ? "active" : ""}
            onClick={() => setIsAnnual(true)}
            aria-pressed={isAnnual}
          >
            Annual Billing{" "}
            <span className="save-badge">
              Save 15%
            </span>
          </button>
        </div>

        {/* Pricing Cards */}
        <div className="pricing-cards">
          {/* Free Plan */}
          <div className="pricing-card">
            <div className="pricing-header">
              <h3>CircleGrid Free</h3>
              <div className="pricing-price">R0</div>
              <div className="pricing-period">forever free</div>
            </div>
            <div className="pricing-features">
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">
                  Free listing on our E-Directory
                </span>
              </div>
            </div>
            <div className="pricing-cta">
              <Link className="cta-button" to="/Signup">Start free</Link>
            </div>
          </div>

          {/* Commented out Starter Plan
          <div className="pricing-card">
            <div className="pricing-header">
              <h3>CircleGrid Starter</h3>
              <div className="pricing-price">{isAnnual ? "R300" : "R29"}</div>
              <div className="pricing-period">
                {isAnnual ? "per year" : "per month"}
              </div>
            </div>
            <div className="pricing-features">
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">
                  Get listed on our E-Directory
                </span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">
                  Weekly WhatsApp group advertising
                </span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">2 Buyer Leads per month</span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">
                  Analytics & Email marketing
                </span>
              </div>
              <div className="feature-item" style={{ opacity: 0.5, textDecoration: "line-through" }}>
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19 13H5v-2h14v2z" />
                </svg>
                <span className="feature-text">
                  Professional Website Builder
                </span>
              </div>
            </div>
            <div className="pricing-cta">
              <button className="cta-button">Get Started</button>
            </div>
          </div>

          {/* Grow Plan - Featured */}
          <div className="pricing-card featured">
            <div className="pricing-header">
              <h3>CircleGrid Grow</h3>
              <div className="pricing-price">{isAnnual ? "R1520" : "R149"}</div>
              <div className="pricing-period">
                {isAnnual ? "per year" : "per month"}
              </div>
            </div>
            <div className="pricing-features">
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">Everything in Free plan</span>
              </div>
              {/* <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">
                  Monthly social media promotion
                </span>
              </div> */}
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">Enhanced directory listing</span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">15 Buyer leads per month</span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">
                  <strong>3-Page Website Builder</strong>
                </span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">Post deals & offers</span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">Write & publish guides</span>
              </div>
            </div>
            <div className="pricing-cta">
              <Link className="cta-button" to="/Signup">Start growing</Link>
            </div>
          </div>

          {/* Boost Plan */}
          <div className="pricing-card">
            <div className="pricing-header">
              <h3>CircleGrid Boost</h3>
              <div className="pricing-price">{isAnnual ? "R5090" : "R499"}</div>
              <div className="pricing-period">
                {isAnnual ? "per year" : "per month"}
              </div>
            </div>
            <div className="pricing-features">
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">Everything in Grow plan</span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">Unlimited enquiries</span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">
                  <strong>3-Page Website Builder</strong>
                </span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">Post deals & offers</span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">Write & publish guides</span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">
                  Unlimited Buyer leads per month
                </span>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                <span className="feature-text">Priority customer support</span>
              </div>
            </div>
            <div className="pricing-cta">
              <Link className="cta-button" to="/Signup">Choose Boost</Link>
            </div>
          </div>
        </div>

        {/* Add-on Services */}
        <div className="addon-section">
          <h3>Supercharge Your Marketing</h3>
          <p
            style={{
              fontSize: "1.1rem",
              color: "#718096",
              marginBottom: "30px",
            }}
          >
            Professional social media advertising campaigns starting from R400
            per platform
          </p>
          <div className="addon-grid">
            <div className="addon-item">
              <h4 style={{ color: "#2d3748", marginBottom: "15px" }}>
                Meta Ads
              </h4>
              <p style={{ color: "#718096", fontSize: "0.95rem" }}>
                Facebook & Instagram campaigns
              </p>
            </div>
            <div className="addon-item">
              <h4 style={{ color: "#2d3748", marginBottom: "15px" }}>
                Google Ads
              </h4>
              <p style={{ color: "#718096", fontSize: "0.95rem" }}>
                Search & display advertising
              </p>
            </div>
            <div className="addon-item">
              <h4 style={{ color: "#2d3748", marginBottom: "15px" }}>
                TikTok Ads
              </h4>
              <p style={{ color: "#718096", fontSize: "0.95rem" }}>
                Reach younger demographics
              </p>
            </div>
            <div className="addon-item">
              <h4 style={{ color: "#2d3748", marginBottom: "15px" }}>
                LinkedIn Ads
              </h4>
              <p style={{ color: "#718096", fontSize: "0.95rem" }}>
                B2B professional targeting
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="pricing-container">
        <div className="faq-section">
          <h1>Frequently Asked Questions</h1>

          <div className="faq-item">
            <button
              type="button"
              className="faq-question"
              aria-expanded={!!open[1]}
              onClick={() => (open[1] ? handleClose(1) : handleOpen(1))}
            >
              <span>
                How do the Additional Options work (Social media ads)?
              </span>
              <svg
                className={`faq-icon ${open[1] ? "open" : ""}`}
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
              </svg>
            </button>
            {open[1] && (
              <div className="faq-answer">
                The Additional Options (Social media ads) are optional and allow
                you to run professional advertising campaigns across social
                media platforms of your choosing. Our team manages the entire
                process from campaign creation to optimization.
              </div>
            )}
          </div>

          <div className="faq-item">
            <button
              type="button"
              className="faq-question"
              aria-expanded={!!open[2]}
              onClick={() => (open[2] ? handleClose(2) : handleOpen(2))}
            >
              <span>What is the fee for Social media ads?</span>
              <svg
                className={`faq-icon ${open[2] ? "open" : ""}`}
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
              </svg>
            </button>
            {open[2] && (
              <div className="faq-answer">
                All social media advertising campaigns are billed at a one-time
                setup fee of R400 per platform. This includes campaign creation,
                targeting optimization, creative development, and performance
                monitoring.
              </div>
            )}
          </div>

          <div className="faq-item">
            <button
              type="button"
              className="faq-question"
              aria-expanded={!!open[3]}
              onClick={() => (open[3] ? handleClose(3) : handleOpen(3))}
            >
              <span>What results can be expected from Social media ads?</span>
              <svg
                className={`faq-icon ${open[3] ? "open" : ""}`}
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
              </svg>
            </button>
            {open[3] && (
              <div className="faq-answer">
                Results vary by platform and industry, but businesses typically
                see increased customer engagement, brand exposure, and lead
                generation. We provide detailed analytics and performance
                reports to track your campaign's success and ROI.
              </div>
            )}
          </div>

          <div className="faq-item">
            <button
              type="button"
              className="faq-question"
              aria-expanded={!!open[4]}
              onClick={() => (open[4] ? handleClose(4) : handleOpen(4))}
            >
              <span>
                Is guidance offered on which Social media platform to run ads?
              </span>
              <svg
                className={`faq-icon ${open[4] ? "open" : ""}`}
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
              </svg>
            </button>
            {open[4] && (
              <div className="faq-answer">
                Absolutely! Based on your business industry, target audience,
                and marketing goals, we provide expert recommendations on the
                best social media platforms to maximize your advertising
                investment and reach your ideal customers.
              </div>
            )}
          </div>

          <div className="faq-item">
            <button
              type="button"
              className="faq-question"
              aria-expanded={!!open[5]}
              onClick={() => (open[5] ? handleClose(5) : handleOpen(5))}
            >
              <span>How do I pay?</span>
              <svg
                className={`faq-icon ${open[5] ? "open" : ""}`}
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
              </svg>
            </button>
            {open[5] && (
              <div className="faq-answer">
                You can select and pay for your plan directly on our Payments
                page using secure online payment methods. For social media
                campaigns, we'll send you a detailed invoice with multiple
                payment options for your convenience.
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Pricing;
